import { render, staticRenderFns } from "./aliintl.vue?vue&type=template&id=9c057f0a&scoped=true"
import script from "./aliintl.vue?vue&type=script&lang=js"
export * from "./aliintl.vue?vue&type=script&lang=js"
import style0 from "./aliintl.vue?vue&type=style&index=0&id=9c057f0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c057f0a",
  null
  
)

export default component.exports